import { Component, Input, OnInit, Output, EventEmitter, AfterContentInit } from '@angular/core'
import { FormGroup, FormBuilder, AbstractControl } from '@angular/forms';
import { LandingSettingsModel } from '@models/index';
import { TranslateService } from '@ngx-translate/core';
import { SentimentCheck } from '../../../core/enums/sentimentChek.enum'
import deepEqual from 'deep-equal'

@Component({
  selector: 'app-landing-page-form',
  templateUrl: './landing-page-form.component.html',
  styleUrls: ['./landing-page-form.component.sass']
})

export class LandingPageFormComponent implements OnInit, AfterContentInit {
  @Input() landingPageModelInput: LandingSettingsModel;
  @Input() sentimentCheckType: string;
  @Input() sentimentCheckEnable: boolean;
  @Input() enablePrivateFeedback: boolean;
  @Output() onCancel = new EventEmitter();
  @Output() onSave = new EventEmitter<LandingSettingsModel>();

  landingPageForm: FormGroup
  selectedTabIndex = 0;
  undoDisable: boolean = true;
  saveDisable: boolean = true;
  toolbarOptions: string[]

  constructor(
    private fb: FormBuilder,
    private translate: TranslateService,
  ) { }

  ngOnInit() {
    this.landingPageForm = this.fb.group({
      wyswygSentimentCheck: [this.landingPageModelInput.wyswygSentimentCheck, this.ValidateSentimentCheckWYSWYG],
      wyswygReviewSite: [this.landingPageModelInput.wyswygReviewSite, this.ValidateReviewSiteWYSWYG],
      wyswygFeedbackMessage: [this.landingPageModelInput.wyswygFeedbackMessage],
      previewImageSentimentCheck: [this.landingPageModelInput.previewImageSentimentCheck],
      previewImageFeedbackMessage: [this.landingPageModelInput.previewImageFeedbackMessage],
      previewImageReviewSite: [this.landingPageModelInput.previewImageReviewSite],
      removePowered: [this.landingPageModelInput.removePowered],
      thumbsUpText: [this.landingPageModelInput.thumbsUpText, this.ValidateText],
      thumbsDownText: [this.landingPageModelInput.thumbsDownText, this.ValidateText],
      happyFaceText: [this.landingPageModelInput.happyFaceText, this.ValidateText],
      neutralFaceText: [this.landingPageModelInput.neutralFaceText, this.ValidateText],
      sadFaceText: [this.landingPageModelInput.sadFaceText, this.ValidateText],
      oneStarText: [this.landingPageModelInput.oneStarText, this.ValidateText],
      twoStarsText: [this.landingPageModelInput.twoStarsText, this.ValidateText],
      threeStarsText: [this.landingPageModelInput.threeStarsText, this.ValidateText],
      fourStarsText: [this.landingPageModelInput.fourStarsText, this.ValidateText],
      fiveStarsText: [this.landingPageModelInput.fiveStarsText, this.ValidateText],
      url: [this.landingPageModelInput.url],
      showWyswygSentimentCheck: false,
      showWyswygReviewSite: false,
      showWyswygFeedbackMessage: false,
    }, {
      validator: (formControl) => ((this.sentimentCheckEnable
        ? ((this.sentimentCheckType == SentimentCheck.Faces ?
          !formControl.value.happyFaceText.trim().length
          || !formControl.value.neutralFaceText.trim().length
          || !formControl.value.sadFaceText.trim().length
          || !formControl.value.wyswygSentimentCheck.replace(/<[^>]*>/g, '').trim().length
          : false)
          || (this.sentimentCheckType == SentimentCheck.Thumbs ?
            !formControl.value.thumbsUpText.trim().length
            || !formControl.value.thumbsDownText.trim().length
            || !formControl.value.wyswygSentimentCheck.replace(/<[^>]*>/g, '').trim().length
            : false)
          || (this.sentimentCheckType == SentimentCheck.Stars ?
            !formControl.value.oneStarText.trim().length
            || !formControl.value.twoStarsText.trim().length
            || !formControl.value.threeStarsText.trim().length
            || !formControl.value.fourStarsText.trim().length
            || !formControl.value.fiveStarsText.trim().length
            || !formControl.value.wyswygSentimentCheck.replace(/<[^>]*>/g, '').trim().length
            : false))
        : false)
        || ((formControl.value.wyswygReviewSite ? !formControl.value.wyswygReviewSite.replace(/<[^>]*>/g, '').trim().length : true))
        || ((formControl.value.wyswygFeedbackMessage ? !formControl.value.wyswygFeedbackMessage.replace(/<[^>]*>/g, '').trim().length : true))
      )
        ? { invalid: true } : null
    })
    this.formChanged();
  }

  ngAfterContentInit() {
    this.toolbarOptions = ['size', 'font', 'colorFnt', 'colorBg', 'bold', 'italic', 'underline', 'orderer', 'unorderer', 'align', 'link', 'code', 'reset']
    setTimeout(() => {
        this.landingPageForm.patchValue({
          showWyswygReviewSite: true
        })
    }, 100)
  }

  formChanged() {
    this.landingPageForm.valueChanges.subscribe(val => {
      this.allowUndo();
      this.allowSave();
    })
  }

  onTab(selectedIndex) {
    this.selectedTabIndex = selectedIndex;
    switch (selectedIndex) {
      case 0:
        setTimeout(() => {
          this.landingPageForm.patchValue({
            showWyswygReviewSite: true
          })
        }, 100)
        break;
      case 1:
        setTimeout(() => {
          this.landingPageForm.patchValue({
            showWyswygFeedbackMessage: true
          })
        }, 100)
        break;
    }
    
  }

  undo() {
    this.selectedTabIndex = 0;

    this.landingPageForm.reset({
      wyswygSentimentCheck: this.landingPageModelInput.wyswygSentimentCheck,
      wyswygReviewSite: this.landingPageModelInput.wyswygReviewSite,
      wyswygFeedbackMessage: this.landingPageModelInput.wyswygFeedbackMessage,
      thumbsUpText: this.landingPageModelInput.thumbsUpText,
      thumbsDownText: this.landingPageModelInput.thumbsDownText,
      happyFaceText: this.landingPageModelInput.happyFaceText,
      neutralFaceText: this.landingPageModelInput.neutralFaceText,
      sadFaceText: this.landingPageModelInput.sadFaceText,
      oneStarText: this.landingPageModelInput.oneStarText,
      twoStarsText: this.landingPageModelInput.twoStarsText,
      threeStarsText: this.landingPageModelInput.threeStarsText,
      fourStarsText: this.landingPageModelInput.fourStarsText,
      fiveStarsText: this.landingPageModelInput.fiveStarsText,
      removePowered: this.landingPageModelInput.removePowered,
      url: this.landingPageModelInput.url,
      showWyswygSentimentCheck: false,
      showWyswygReviewSite: false,
      showWyswygFeedbackMessage: false
    }
    )

    setTimeout(() => {
      this.landingPageForm.patchValue({
        showWyswygReviewSite: true
      })
    
    }, 100)

  }

  allowUndo() {
    let tempLandingSettings = {...{},...this.landingPageForm.value}

    delete tempLandingSettings.showWyswygSentimentCheck
    delete tempLandingSettings.showWyswygReviewSite
    delete tempLandingSettings.showWyswygFeedbackMessage

    this.undoDisable = deepEqual(this.landingPageModelInput, tempLandingSettings);
  }
  allowSave() {
    let tempLandingSettings = {...{},...this.landingPageForm.value}

    delete tempLandingSettings.showWyswygSentimentCheck
    // delete tempLandingSettings.showWyswygReviewSite
    delete tempLandingSettings.showWyswygFeedbackMessage

    this.saveDisable = !this.landingPageForm.valid || deepEqual(this.landingPageModelInput, tempLandingSettings);
  }

  ValidateText(control: AbstractControl) {
    if(control.value && control.value.trim().length){
      return null;
    }
    return {invalid: true};
  }

  ValidateSentimentCheckWYSWYG(control: AbstractControl) {
    const sentimentCheckDivider =  `<p class="ql-align-center"><strong style="background-color: rgb(187, 187, 187);"> Sentiment Check Buttons </strong></p>`;
    if(control.value && control.value.includes(sentimentCheckDivider)){
      return null;
    }
    return {invalid: true};
  }

  ValidateReviewSiteWYSWYG(control: AbstractControl) {
    const reviewSectionDivider1 = '<p class="ql-align-center"><br></p><p class="ql-align-center"><strong style="background-color: rgb(187, 187, 187);"> Review Site Buttons </strong></p>';
    const reviewSectionDivider2 = '<p class="ql-align-center"><strong style="background-color: rgb(187, 187, 187);"> Review Check us Out Sites </strong></p>';
    const reviewSectionDivider3 = '<p class="ql-align-center"><strong style="background-color: rgb(187, 187, 187);"> Feedback Button </strong></p>';
    if(control.value 
      && control.value.includes(reviewSectionDivider1) 
      && control.value.includes(reviewSectionDivider2) 
    ){
      return null;
    }
    return {invalid: true};
  }
}
